import { render, staticRenderFns } from "./WorkplaceEdit.vue?vue&type=template&id=3f8ff3fa"
import script from "./WorkplaceEdit.js?vue&type=script&lang=js&external"
export * from "./WorkplaceEdit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports